module.exports = __webpack_public_path__ + "housingStatic/img/tip.911c2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tip.png
// module id = RAvV
// module chunks = 2